/* HEPI "התאמה לחצר" swipe deck. Markup: templates/page.match.liquid.
   Swipe right = like, left = skip. The same three actions are buttons, and the
   arrow keys work, so nothing depends on being able to drag.
   Direction is physical on purpose (right = like), as in every swipe app,
   even though the page reads right-to-left.
   The liked list lives in localStorage only; every read and write is wrapped,
   because storage can be blocked and the page must work without it.
   Shopify.analytics.publish sends custom events (hepi_match_*) that a custom
   pixel can pick up later to measure how many people reach the end. */
(function () {
  var root = document.getElementById('hepiMatch');
  var dataEl = document.getElementById('hepiMatchData');
  if (!root || !dataEl) return;

  var pool = [];
  try { pool = JSON.parse(dataEl.textContent) || []; } catch (e) { pool = []; }
  if (pool.length < 3) return;

  var DECK_SIZE = 12;
  var THRESHOLD = 100;          // px of horizontal drag that counts as a decision
  var KEY = 'hepiMatchLiked';
  var WA = root.getAttribute('data-wa');
  var SHOP = (root.getAttribute('data-shop') || '').replace(/\/$/, '');
  var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var play = root.querySelector('.hm-play');
  var deckEl = root.querySelector('.hm-deck');
  var endEl = root.querySelector('.hm-end');
  var bar = root.querySelector('.hm-progress__bar');
  var countEl = root.querySelector('.hm-count');
  var live = root.querySelector('.hm-live');
  var btnNo = root.querySelector('.hm-btn--no');
  var btnYes = root.querySelector('.hm-btn--yes');
  var btnUndo = root.querySelector('.hm-btn--undo');
  var savedBtn = root.querySelector('.hm-saved');

  var deck = [], idx = 0, liked = [], history = [], busy = false;

  /* The personal result. "st" and "sz" come from each product's own title and
     description (see the template); the copy below only describes the look, it
     makes no claim about any particular product. */
  var STYLES = {
    rope:   { n: 'טבעי ונינוח', d: 'קליעה, חבלים וראטן. מראה רך וחם, לחצר שרוצים להתרווח בה ולהישאר בה עד מאוחר.' },
    wood:   { n: 'חם ועצי',     d: 'מראה של עץ שמכניס חום לחצר, ונראה טוב גם כשהיא ריקה מאנשים.' },
    modern: { n: 'מודרני ונקי', d: 'קווים ישרים, אלומיניום וגוונים שקטים. נראה מסודר, ומשתלב בכל מרפסת.' }
  };
  var SIZES = {
    big:   'ואתם אוהבים לארח: סטים גדולים, פינתיים ושולחנות לשישה ומעלה.',
    small: 'ואתם מעדיפים משהו קומפקטי, לזוג או למשפחה קטנה.'
  };

  /* The most liked value of key k, if it carries at least 40% of the likes and
     appears at least twice. Otherwise nothing: a guess is worse than no result. */
  function top(list, k) {
    var n = {}, best = '', bestN = 0, known = 0;
    list.forEach(function (d) { var v = d[k]; if (!v) return; known++; n[v] = (n[v] || 0) + 1; if (n[v] > bestN) { best = v; bestN = n[v]; } });
    return bestN >= 2 && bestN / list.length >= 0.4 ? best : '';
  }
  function result(list) {
    var st = top(list, 'st'), sz = top(list, 'sz');
    return st ? { st: st, n: STYLES[st].n, d: STYLES[st].d, s: sz ? SIZES[sz] : '' } : null;
  }
  /* Three models in the same style that the visitor has not seen in this round. */
  function recos(st, list) {
    var seen = {};
    deck.concat(list).forEach(function (d) { seen[d.v] = 1; });
    return shuffle(pool.filter(function (d) { return d.st === st && !seen[d.v]; })).slice(0, 3);
  }

  function track(name, payload) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, payload || {}); } catch (e) {}
  }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }
  function load() {
    try { var v = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(v) ? v : []; } catch (e) { return []; }
  }
  function save() {
    try { localStorage.setItem(KEY, JSON.stringify(liked)); } catch (e) {}
  }
  function shuffle(a) {
    for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = a[i]; a[i] = a[j]; a[j] = t; }
    return a;
  }

  /* Shuffle each category, then deal them in turn, so seating and dining alternate. */
  function buildDeck() {
    var groups = {}, order = [];
    pool.forEach(function (d) { if (!groups[d.c]) { groups[d.c] = []; order.push(d.c); } groups[d.c].push(d); });
    var piles = order.map(function (k) { return shuffle(groups[k].slice()); });
    var out = [];
    while (out.length < DECK_SIZE && piles.some(function (p) { return p.length; })) {
      piles.forEach(function (p) { if (p.length && out.length < DECK_SIZE) out.push(p.shift()); });
    }
    return out;
  }

  function makeCard(d, top) {
    var el = document.createElement('article');
    el.className = 'hm-card ' + (top ? 'is-top' : 'is-next');
    el.setAttribute('aria-label', d.c + ': ' + d.t + ', ' + d.p);
    el.innerHTML =
      '<img class="hm-card__img" src="' + esc(d.i) + '" alt="" draggable="false">' +
      '<span class="hm-card__shade"></span>' +
      '<span class="hm-stamp hm-stamp--yes" aria-hidden="true">אהבתי</span>' +
      '<span class="hm-stamp hm-stamp--no" aria-hidden="true">לא בשבילי</span>' +
      '<div class="hm-card__info">' +
        '<span class="hm-card__cat">' + esc(d.c) + '</span>' +
        '<h2 class="hm-card__t">' + esc(d.t) + '</h2>' +
        '<div class="hm-card__row"><span class="hm-card__p" dir="ltr">' + esc(d.p) + '</span>' +
        '<a class="hm-card__more" href="' + esc(d.u) + '" target="_blank" rel="noopener">לפרטי הדגם</a></div>' +
      '</div>';
    if (top) drag(el);
    return el;
  }

  function drag(el) {
    var sx = 0, dx = 0, id = null, on = false;
    el.addEventListener('pointerdown', function (e) {
      if (busy || e.target.closest('a')) return;
      on = true; id = e.pointerId; sx = e.clientX; dx = 0;
      try { el.setPointerCapture(id); } catch (err) {}
      el.classList.add('is-dragging');
    });
    el.addEventListener('pointermove', function (e) {
      if (!on || e.pointerId !== id) return;
      dx = e.clientX - sx;
      el.style.transform = 'translateX(' + dx + 'px) rotate(' + (dx / 16) + 'deg)';
      var r = Math.max(-1, Math.min(1, dx / THRESHOLD));
      el.style.setProperty('--yes', Math.max(0, r));
      el.style.setProperty('--no', Math.max(0, -r));
    });
    function end() {
      if (!on) return;
      on = false; el.classList.remove('is-dragging');
      if (dx > THRESHOLD) decide(true);
      else if (dx < -THRESHOLD) decide(false);
      else { el.style.transform = ''; el.style.setProperty('--yes', 0); el.style.setProperty('--no', 0); }
    }
    el.addEventListener('pointerup', end);
    el.addEventListener('pointercancel', end);
  }

  function render() {
    if (idx >= deck.length) { finish(); return; }
    deckEl.innerHTML = '';
    if (idx + 1 < deck.length) deckEl.appendChild(makeCard(deck[idx + 1], false));
    deckEl.appendChild(makeCard(deck[idx], true));
    bar.style.width = Math.round(idx / deck.length * 100) + '%';
    countEl.textContent = (idx + 1) + ' מתוך ' + deck.length;
    btnUndo.disabled = history.length === 0;
    if (idx + 2 < deck.length) { var pre = new Image(); pre.src = deck[idx + 2].i; }
  }

  function decide(like) {
    if (busy || idx >= deck.length) return;
    busy = true;
    var el = deckEl.querySelector('.hm-card.is-top');
    var d = deck[idx];
    var dir = like ? 1 : -1;
    history.push({ like: like });
    if (like) { liked.push(d); save(); }
    track(like ? 'hepi_match_like' : 'hepi_match_skip', { title: d.t });
    live.textContent = (like ? 'אהבתם: ' : 'דילגתם על: ') + d.t;
    if (el) {
      el.style.setProperty(like ? '--yes' : '--no', 1);
      el.style.transition = calm ? 'none' : 'transform .32s ease-out, opacity .32s ease-out';
      el.style.transform = 'translateX(' + (dir * (window.innerWidth + 200)) + 'px) rotate(' + (dir * 22) + 'deg)';
      el.style.opacity = '0';
    }
    setTimeout(function () { idx++; busy = false; render(); }, calm ? 0 : 260);
  }

  function undo() {
    if (busy || !history.length) return;
    var h = history.pop();
    idx--;
    if (h.like) { liked.pop(); save(); }
    endEl.hidden = true; play.hidden = false;
    live.textContent = 'חזרתם לכרטיס הקודם';
    render();
  }

  function waLink(list, res) {
    var lines = ['שלום, עשיתי התאמה לחצר באתר' + (res ? ' (יצא לי סגנון ' + res.n + ')' : '') + ' ואהבתי את הדגמים האלה:'];
    list.forEach(function (d, i) { lines.push((i + 1) + '. ' + d.t + ' (' + d.p + ')', SHOP + d.u); });
    lines.push('אשמח לעזרה בבחירה.');
    return 'https://wa.me/' + WA + '?text=' + encodeURIComponent(lines.join('\n'));
  }

  function finish(list) {
    var shown = list || liked;
    var res = result(shown);
    var more = res ? recos(res.st, shown) : [];
    play.hidden = true; endEl.hidden = false;
    if (!list) track('hepi_match_finish', { liked: liked.length, size: deck.length, style: res ? res.st : '' });
    var html;
    if (!shown.length) {
      html =
        '<h2 class="hm-end__t">עוד לא מצאתם את ה"אחד"</h2>' +
        '<p class="hm-end__s">זה בסדר. אפשר לנסות סבב חדש עם דגמים אחרים, או לספר לנו בוואטסאפ מה אתם מחפשים ונציע בעצמנו.</p>' +
        '<div class="hm-end__acts">' +
          '<button class="hm-cta" type="button" data-act="again">סבב חדש</button>' +
          '<a class="hm-ghost" href="https://wa.me/' + WA + '" target="_blank" rel="noopener">לדבר איתנו בוואטסאפ</a>' +
        '</div>';
    } else {
      html =
        (res ?
          '<div class="hm-res">' +
            '<span class="hm-res__k">הסגנון שלכם</span>' +
            '<strong class="hm-res__n">' + esc(res.n) + '</strong>' +
            '<p class="hm-res__d">' + esc(res.d) + (res.s ? ' ' + esc(res.s) : '') + '</p>' +
          '</div>' : '') +
        '<h2 class="hm-end__t">' + (shown.length === 1 ? 'אהבתם דגם אחד' : 'אהבתם ' + shown.length + ' דגמים') + '</h2>' +
        '<p class="hm-end__s">שלחו לנו את הרשימה בוואטסאפ: נעזור לבחור מתוכה, נבדוק שהמידות מתאימות לשטח ונתאם משלוח.</p>' +
        '<ul class="hm-list" role="list">' +
        shown.map(function (d) {
          return '<li class="hm-li">' +
            '<a class="hm-li__img" href="' + esc(d.u) + '"><img src="' + esc(d.s || d.i) + '" alt="" loading="lazy"></a>' +
            '<a class="hm-li__b" href="' + esc(d.u) + '"><span class="hm-li__t">' + esc(d.t) + '</span><span class="hm-li__p" dir="ltr">' + esc(d.p) + '</span></a>' +
            '<button class="hm-li__add" type="button" data-v="' + esc(d.v) + '" aria-label="הוספה לסל: ' + esc(d.t) + '"><i class="ti ti-shopping-cart-plus" aria-hidden="true"></i></button>' +
          '</li>';
        }).join('') +
        '</ul>' +
        '<div class="hm-end__acts">' +
          '<a class="hm-cta" data-act="wa" href="' + waLink(shown, res) + '" target="_blank" rel="noopener"><i class="ti ti-brand-whatsapp" aria-hidden="true"></i> שליחת הרשימה אלינו בוואטסאפ</a>' +
          '<button class="hm-ghost" type="button" data-act="again">סבב נוסף עם דגמים אחרים</button>' +
        '</div>' +
        (more.length ?
          '<div class="hm-more">' +
            '<h3 class="hm-more__t">עוד בסגנון ' + esc(res.n) + ' שעוד לא ראיתם</h3>' +
            '<ul class="hm-more__row" role="list">' +
            more.map(function (d) {
              return '<li><a class="hm-more__card" data-act="reco" href="' + esc(d.u) + '">' +
                '<span class="hm-more__img"><img src="' + esc(d.i) + '" alt="" loading="lazy"></span>' +
                '<span class="hm-more__name">' + esc(d.t) + '</span>' +
                '<span class="hm-more__p" dir="ltr">' + esc(d.p) + '</span>' +
              '</a></li>';
            }).join('') +
            '</ul>' +
          '</div>' : '');
    }
    endEl.innerHTML = html;
    try { endEl.focus({ preventScroll: true }); } catch (e) { endEl.focus(); }
    endEl.scrollIntoView({ behavior: calm ? 'auto' : 'smooth', block: 'start' });
  }

  function start() {
    deck = buildDeck(); idx = 0; liked = []; history = [];
    save();
    endEl.hidden = true; play.hidden = false;
    track('hepi_match_start', { size: deck.length });
    render();
  }

  btnYes.addEventListener('click', function () { decide(true); });
  btnNo.addEventListener('click', function () { decide(false); });
  btnUndo.addEventListener('click', undo);
  document.addEventListener('keydown', function (e) {
    if (play.hidden || e.altKey || e.ctrlKey || e.metaKey) return;
    var t = e.target.tagName;
    if (t === 'INPUT' || t === 'TEXTAREA' || t === 'SELECT') return;
    if (e.key === 'ArrowRight') { e.preventDefault(); decide(true); }
    else if (e.key === 'ArrowLeft') { e.preventDefault(); decide(false); }
  });
  endEl.addEventListener('click', function (e) {
    var t = e.target.closest('[data-act],[data-v]');
    if (!t) return;
    if (t.getAttribute('data-act') === 'again') { start(); return; }
    if (t.getAttribute('data-act') === 'wa') { track('hepi_match_whatsapp', { liked: liked.length }); return; }
    if (t.getAttribute('data-act') === 'reco') { track('hepi_match_reco_click', { url: t.getAttribute('href') }); return; }
    var v = parseInt(t.getAttribute('data-v'), 10);
    if (!v) return;
    track('hepi_match_add_to_cart', { variant: v });
    if (typeof window.addToCartAjax === 'function') { window.addToCartAjax(v, t); return; }
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: v, quantity: 1 }] }) })
      .then(function (r) { if (r.ok) location.href = '/cart'; });
  });

  /* A list from an earlier visit is offered, never forced: the deck starts fresh. */
  var earlier = load();
  if (earlier.length && savedBtn) {
    savedBtn.textContent = 'הרשימה שלכם מהביקור הקודם (' + earlier.length + ')';
    savedBtn.hidden = false;
    savedBtn.addEventListener('click', function () { liked = earlier.slice(); finish(earlier); savedBtn.hidden = true; });
  }

  deck = buildDeck();
  track('hepi_match_start', { size: deck.length });
  render();
})();
